import { DataTable } from '../../../../../../../../components/UI/MDC/DataTable/DataTable';
import AppExtensionUpdate from './AppExtensionsUpdate';

const AppExtensionsDisplay = ({
	app,
	currentUser,
	appExtensions,
	setAppExtensions,
	readOnly,
	requirementNumber,
}) => {
	const headers = [
		{ Value: 'Level', props: { sort: null, onSortChange: null } },
		{ Value: 'Approvers', props: { sort: null, onSortChange: null } },
		{ Value: 'Extension Type', props: { sort: null, onSortChange: null } },
		{ Value: 'Actions', props: { sort: null, onSortChange: null } },
	];

	const rows = appExtensions
		?.sort((a, b) => a.Order - b.Order)
		.map((ext, index) => {
			return {
				Cells: {
					Level: {
						Value: ext.Order ? ext.Order : null,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Approvers: {
						Value: ext.ApproveAppCre_Email,

						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					'Extension Type': {
						Value: ext.Extension?.FIID,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Actions: {
						Value: (
							<AppExtensionUpdate
								appExtension={ext}
								app={app}
								currentUser={currentUser}
								setAppExtensions={setAppExtensions}
								readOnly={readOnly}
								requirementNumber={requirementNumber}
							/>
						),
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
				},
				Key: ext.ID.toString(),
			};
		});

	return (
		<div>
			<DataTable rows={rows} headers={headers} />
		</div>
	);
};

export default AppExtensionsDisplay;

//private components--------------------------------
